<div class="card">
  <h2 class="ml-3 mt-2">Manuais</h2>
  <div class="card-body">
    <div class="list-group">
      <a class="list-group-item list-group-item-action" [href]="inviteAuthor" download>
        <i class='bx bxs-file-pdf'></i> Tutorial PDF - Convidar autor, orientador, Coorientador ou mentor.
      </a>
      <a class="list-group-item list-group-item-action" [href]="href" download>
        <i class='bx bxs-file-pdf'></i> Desvendando a Plataforma Escritha - Módulo 1.
      </a>
      <!-- <a class="list-group-item list-group-item-action">
        <i class='bx bxs-file-pdf'></i> Desvendando a Produção Científica com a Plataforma Escritha - Módulo 2.
      </a> -->
    </div>
  </div>
  <h2 class="ml-3 mt-2">Modelos</h2>
  <div class="card-body">
    <div class="list-group">
      <a *ngFor="let model of models" class="list-group-item list-group-item-action" [href]="model.href" download>
        <i class='bx bxs-file-pdf'></i> {{ model.description }}.
      </a>
    </div>
  </div>
</div>